@if (hasBriefing) {
  <div class="persona-briefing">
    @if (persona.scene) {
      <div class="persona-briefing__row">
        <span class="persona-briefing__label">場面</span>
        <span class="persona-briefing__value">{{ persona.scene }}</span>
      </div>
    }
    @if (persona.purpose) {
      <div class="persona-briefing__row">
        <span class="persona-briefing__label">目的</span>
        <span class="persona-briefing__value">{{ persona.purpose }}</span>
      </div>
    }
    @if (persona.estimatedMinutes != null) {
      <div class="persona-briefing__row">
        <span class="persona-briefing__label">目安所要時間</span>
        <span class="persona-briefing__value"
          >約 {{ persona.estimatedMinutes }} 分</span
        >
      </div>
    }
  </div>
}
